<template>
  <v-dialog
    v-model="fileUploadVisible"
    width="800"
    @click:outside="cancelFileUpload()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        :disabled="btnDisabledFileUpload"
        v-bind="attrs"
        v-on="on"
        class="btn ml-2"
        >{{ $t('File Upload') }}</v-btn
      >
    </template>
    <v-card class="popup add_store_popup">
      <h3 class="page-title-bar">
        <i class="ico ico-product"></i>{{ $t('File Upload') }}
      </h3>
      <v-row>
        <v-col>
          <v-file-input
            outlined
            dense
            hide-details
            prepend-icon
            solo
            flat
            :placeholder="`${$t('Select file')}`"
            class="form-file"
            v-model="files"
          >
            <template v-slot:append>
              <img
                width="24"
                height="24"
                src="@/assets/img/ico-upload-file.gif"
              />
            </template>
          </v-file-input>
          <p class="txt-s mt-1 ml-2">* Max. File Size  : 20M</p>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col>
          <p class="label-txt">{{ $t('Selected Files') }}</p>
          <ul class="selectedFile-list mt-2">
            <li v-for="file in filesToUpload" :key="file.name">
              <p>{{ file.name }}</p>
              <v-btn @click="removeFile(file.name)" text icon
                ><img width="24" height="24" src="@/assets/img/ico-delete2.png"
              /></v-btn>
            </li>
          </ul>
        </v-col>
      </v-row> -->
      <v-card-actions class="d-flex justify-center">
        <v-btn text icon @click="uploadFiles()" class="btn">{{
          $t('Upload')
        }}</v-btn>
        <v-btn text icon @click="cancelFileUpload()" class="btn">{{
          $t('Cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import commons from '@/plugins/commons'
// Mixins
import MsgBoxParent from '@/mixins/MsgBoxParent'
import FileUploader from '@/mixins/FileUploader'
export default {
  mixins: [FileUploader, MsgBoxParent],

  props: {
    btnDisabledFileUpload: Boolean,
    store: Object
  },
  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      requests: {
        uploadFiles: {
          method: 'post',
          url: '/api/common/articles/upload'
        }
      },
      files: null,
      filesToUpload: [],
      fileUploadVisible: false
    }
  },
  methods: {
    cancelFileUpload () {
      this.files = null
      this.filesToUpload = []
      this.toggleFileUpload()
    },
    toggleFileUpload () {
      this.fileUploadVisible = !this.fileUploadVisible
    },
    appendFiles () {
      this.filesToUpload = [...this.filesToUpload, ...this.files]
      this.files = []
    },
    removeFile (fileName) {
      this.filesToUpload = this.filesToUpload.filter(
        file => file.name !== fileName
      )
    },
    async buildFileUploadBody (files) {
      console.log(files)
      const fileDataList = []
      const fileData = {}
      fileData.contentType = 'IMAGE'
      fileData.imgBase64 = await commons.getBase64(files)
      fileData.pageIndex = 1
      fileData.fileName = files.name
      fileDataList.push(fileData)
      return fileDataList
    },
    async uploadFiles () {
      console.log(this.files)
      // const files = this.filesToUpload
      if (this.files === null || this.files === undefined) {
        EventBus.$emit('messageAlert', this.$t('Select files to upload.'))
        return
      }
      const reqBody = await this.buildFileUploadBody(this.files)
      const params = { store: this.store.code }
      const config = { params: params }
      const body = {
        contentType: reqBody[0].contentType,
        imgBase64: reqBody[0].imgBase64,
        pageIndex: reqBody[0].pageIndex,
        fileName: reqBody[0].fileName
      }

      if (this.productionType === 'cloud') {
        params.company = this.$store.state.auth.user.company
      }

      this.$utils
        .callAxiosWithBody(
          this.requests.uploadFiles.method,
          this.requests.uploadFiles.url,
          body,
          config
        )
        .then(res => {
          EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
          this.cancelFileUpload()
        })
        .catch(error => {
          switch (error.response.status) {
            default:
              EventBus.$emit('messageAlert', this.$t('The file format is not matched with the field configuration. Please check the configuration in Product File Config.'))
              break
          }
          this.cancelFileUpload()
        })
    }
  }
}
</script>

<style></style>
